/* KRYØS — WebGL: 3D lure viewer + abyssal hero shader */
(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s), $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const K = (window.KY = window.KY || {});
  const reduce = false;
  const MOBILE = matchMedia('(hover: none), (max-width: 760px)').matches;
  const DPR = Math.min(MOBILE ? 1.5 : 2, devicePixelRatio || 1);
  let pageVisible = !document.hidden;
  document.addEventListener('visibilitychange', () => (pageVisible = !document.hidden));
  // mobile : pendant le défilement au doigt, les canvas 3D gardent leur dernière image ; l'animation reprend dès que le doigt s'arrête
  let scrolling = false, scrollT = 0;
  if (MOBILE) addEventListener('scroll', () => { scrolling = true; clearTimeout(scrollT); scrollT = setTimeout(() => (scrolling = false), 140); }, { passive: true }); // animations toujours actives (choix client), même si l'OS demande de les réduire

  const SHAPES = {
    minnow: { sx: 2.4, sy: 0.72, sz: 0.62, lip: [2.5, -0.3], lipRot: -0.5, hooks: [-0.4, -1.4] },
    popper: { sx: 2.0, sy: 0.9, sz: 0.78, lip: [2.15, -0.05], lipRot: -1.1, hooks: [-0.2, -1.3] },
    jerk: { sx: 2.7, sy: 0.55, sz: 0.52, lip: [2.85, -0.25], lipRot: -0.3, hooks: [-0.6, -1.7] },
  };

  function buildLure(shape, colorHex) {
    const S = SHAPES[shape] || SHAPES.minnow;
    const group = new THREE.Group();
    const bodyMat = new THREE.MeshPhysicalMaterial({ color: colorHex, metalness: 0.65, roughness: 0.25, clearcoat: 1, clearcoatRoughness: 0.1 });
    const body = new THREE.Mesh(new THREE.SphereGeometry(1, 48, 32), bodyMat); body.scale.set(S.sx, S.sy, S.sz); group.add(body);
    const back = new THREE.Mesh(new THREE.SphereGeometry(1, 32, 24), new THREE.MeshPhysicalMaterial({ color: 0x0e1a22, metalness: 0.9, roughness: 0.3 }));
    back.scale.set(S.sx - 0.05, S.sy * 0.62, S.sz - 0.04); back.position.y = S.sy * 0.44; group.add(back);
    const belly = new THREE.Mesh(new THREE.SphereGeometry(1, 32, 16), new THREE.MeshStandardMaterial({ color: 0xfff2cf, emissive: 0x3aa5ff, emissiveIntensity: 0.55, metalness: 0.8, roughness: 0.2 }));
    belly.scale.set(S.sx - 0.3, S.sy * 0.4, S.sz - 0.12); belly.position.y = -S.sy * 0.7; group.add(belly);
    const lip = new THREE.Mesh(new THREE.BoxGeometry(0.5, 0.06, 0.5), new THREE.MeshPhysicalMaterial({ color: 0x7fe3f0, transparent: true, opacity: 0.85, roughness: 0.1 }));
    lip.position.set(S.lip[0], S.lip[1], 0); lip.rotation.z = S.lipRot; group.add(lip);
    [-1, 1].forEach((s) => { const e = new THREE.Mesh(new THREE.SphereGeometry(0.13, 16, 16), new THREE.MeshStandardMaterial({ color: 0x000000, roughness: 0.1 })); e.position.set(S.sx * 0.7, S.sy * 0.25, s * S.sz * 0.68); group.add(e); });
    S.hooks.forEach((x) => { const h = new THREE.Mesh(new THREE.TorusGeometry(0.22, 0.035, 10, 24), new THREE.MeshStandardMaterial({ color: 0xd7dde3, metalness: 1, roughness: 0.2 })); h.position.set(x, -S.sy - 0.05, 0); group.add(h); });
    const ring = new THREE.Mesh(new THREE.TorusGeometry(2.9, 0.012, 8, 90), new THREE.MeshBasicMaterial({ color: 0x4fc3ff, transparent: true, opacity: 0.35 }));
    ring.rotation.x = Math.PI / 2.4; group.add(ring);
    const ring2 = new THREE.Mesh(new THREE.TorusGeometry(3.4, 0.008, 8, 90), new THREE.MeshBasicMaterial({ color: 0x7fe3f0, transparent: true, opacity: 0.22 }));
    ring2.rotation.x = Math.PI / 1.9; ring2.rotation.y = 0.4; group.add(ring2);
    return { group, bodyMat, belly, ring, ring2 };
  }

  function initProcLure(canvas) {
    if (canvas.dataset.l3 || !window.THREE) return;
    canvas.dataset.l3 = '1';
    const shape = canvas.dataset.shape || 'minnow';
    const color = parseInt((canvas.dataset.color || '#4fc3ff').replace('#', ''), 16);
    const hero = canvas.hasAttribute('data-hero-lure');
    const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
    const scene = new THREE.Scene(); const cam = new THREE.PerspectiveCamera(38, 1, 0.1, 100); cam.position.set(0, 1.2, 7.5);
    scene.add(new THREE.AmbientLight(0x8899aa, 0.9));
    const k1 = new THREE.PointLight(0x4fc3ff, 2.2, 20); k1.position.set(3, 2, 3); scene.add(k1);
    const k2 = new THREE.PointLight(0x7fe3f0, 1.4, 20); k2.position.set(-3, -1, 2); scene.add(k2);
    const dir = new THREE.DirectionalLight(0xffffff, 1); dir.position.set(0, 4, 4); scene.add(dir);
    const L = buildLure(shape, color); scene.add(L.group);
    // particles (plankton)
    const pn = 140, pg = new THREE.BufferGeometry(), pa = new Float32Array(pn * 3);
    for (let i = 0; i < pn; i++) { pa[i * 3] = (Math.random() - 0.5) * 14; pa[i * 3 + 1] = (Math.random() - 0.5) * 7; pa[i * 3 + 2] = (Math.random() - 0.5) * 8; }
    pg.setAttribute('position', new THREE.BufferAttribute(pa, 3));
    const pts = new THREE.Points(pg, new THREE.PointsMaterial({ color: 0x7fe3f0, size: 0.03, transparent: true, opacity: 0.6 }));
    scene.add(pts);

    function size() {
      const w = canvas.clientWidth, h = canvas.clientHeight; if (!w || !h) return;
      renderer.setPixelRatio(Math.min(2, devicePixelRatio)); renderer.setSize(w, h, false);
      cam.aspect = w / h; cam.updateProjectionMatrix();
    }
    size(); addEventListener('resize', size);
    let rx = 0.15, ry = 0.6, tx = rx, ty = ry, drag = false, px = 0, scrollRot = 0, boost = 0, visible = true;
    canvas.addEventListener('pointermove', (e) => { if (drag) return; const r = canvas.getBoundingClientRect(); tx = ((e.clientY - r.top) / r.height - 0.5) * 1.2; ty = ((e.clientX - r.left) / r.width - 0.5) * 2; });
    canvas.addEventListener('pointerdown', (e) => { drag = true; px = e.clientX; canvas.setPointerCapture?.(e.pointerId); });
    addEventListener('pointerup', () => (drag = false));
    addEventListener('pointermove', (e) => { if (drag) { ty += (e.clientX - px) * 0.012; boost = (e.clientX - px) * 0.02; px = e.clientX; } });
    new IntersectionObserver((es) => (visible = es[0].isIntersecting), { threshold: 0 }).observe(canvas);
    if (hero) addEventListener('scroll', () => (scrollRot = window.scrollY * 0.0025), { passive: true });

    const api = {
      setColor(hex) { const c = new THREE.Color(hex); const from = L.bodyMat.color.clone(); let t = 0; (function step() { t += 0.06; L.bodyMat.color.copy(from).lerp(c, Math.min(1, t)); if (t < 1) requestAnimationFrame(step); })(); },
      pulse() { boost = 0.5; },
    };
    canvas._lure = api;

    const t00 = performance.now();
    (function loop(now) {
      requestAnimationFrame(loop);
      if (!visible || !pageVisible) return;
      const t = now - t00;
      ry += (ty - ry) * 0.06; rx += (tx - rx) * 0.06; boost *= 0.92;
      L.group.rotation.y = ry + scrollRot + Math.sin(t * 0.0004) * 0.25 + boost;
      L.group.rotation.x = rx + (hero ? Math.sin(scrollRot) * 0.2 : 0);
      L.group.position.y = Math.sin(t * 0.0012) * 0.18;
      L.belly.material.emissiveIntensity = 0.4 + Math.abs(Math.sin(t * 0.003)) * 0.7;
      L.ring.rotation.z = t * 0.0003; L.ring2.rotation.z = -t * 0.0002;
      pts.rotation.y = t * 0.00004; pts.position.y = Math.sin(t * 0.0006) * 0.1;
      renderer.render(scene, cam);
    })(0);
  }

  /* ---------- Modèle 3D « à l'identique » : photo catalogue détourée + volume gonflé ---------- */
  const loadImg = (src) => new Promise((res, rej) => { const i = new Image(); i.crossOrigin = 'anonymous'; i.onload = () => res(i); i.onerror = rej; i.src = src; });
  function pixels(img, w, h) { const c = document.createElement('canvas'); c.width = w; c.height = h; const x = c.getContext('2d'); x.drawImage(img, 0, 0, w, h); return x.getImageData(0, 0, w, h).data; }
  const envCaches = new WeakMap();
  function envMap(renderer) {
    if (envCaches.has(renderer)) return envCaches.get(renderer);
    const s = new THREE.Scene(); s.background = new THREE.Color(0x05090d);
    const panel = (w, h, color, x, y, z, ry, rx) => { const m = new THREE.Mesh(new THREE.PlaneGeometry(w, h), new THREE.MeshBasicMaterial({ color, side: THREE.DoubleSide })); m.position.set(x, y, z); m.rotation.set(rx || 0, ry || 0, 0); s.add(m); };
    panel(10, 3, 0xffffff, 0, 6, 0, 0, Math.PI / 2);
    panel(4, 6, 0x4fc3ff, -7, 1, 0, Math.PI / 2);
    panel(4, 6, 0x7fe3f0, 7, 0, 1, -Math.PI / 2);
    panel(8, 2, 0xf2ede4, 0, 1, -7, 0);
    const pm = new THREE.PMREMGenerator(renderer);
    const tex = pm.fromScene(s, 0.04).texture; pm.dispose();
    envCaches.set(renderer, tex);
    return tex;
  }
  async function buildPhotoLure(renderer, texUrl, depthUrl, thick) {
    const [ti, di] = await Promise.all([loadImg(texUrl), loadImg(depthUrl)]);
    const aspect = ti.height / ti.width, W = 5, H = W * aspect;
    const NX = MOBILE ? 170 : 240, NY = Math.max(40, Math.round(NX * aspect)); // maillage allégé sur mobile (invisible à cette taille)
    const A = pixels(ti, NX + 1, NY + 1), D = pixels(di, NX + 1, NY + 1);
    const T = thick * W;
    const pos = [], uv = [], idx = [], per = (NX + 1) * (NY + 1);
    for (let k = 0; k < 2; k++) for (let j = 0; j <= NY; j++) for (let i = 0; i <= NX; i++) {
      const q = (j * (NX + 1) + i) * 4, d = A[q + 3] < 128 ? 0 : D[q] / 255;
      pos.push(-W / 2 + (i / NX) * W, H / 2 - (j / NY) * H, (k ? -1 : 1) * d * T);
      uv.push(i / NX, 1 - j / NY);
    }
    const alpha = (i, j) => A[(j * (NX + 1) + i) * 4 + 3];
    for (let j = 0; j < NY; j++) for (let i = 0; i < NX; i++) {
      if (Math.max(alpha(i, j), alpha(i + 1, j), alpha(i, j + 1), alpha(i + 1, j + 1)) < 20) continue;
      const a = j * (NX + 1) + i, b = a + 1, c = a + NX + 1, e = c + 1;
      idx.push(a, c, b, b, c, e);
      idx.push(per + a, per + b, per + c, per + b, per + e, per + c);
    }
    const g = new THREE.BufferGeometry();
    g.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
    g.setAttribute('uv', new THREE.Float32BufferAttribute(uv, 2));
    g.setIndex(idx); g.computeVertexNormals();
    const map = new THREE.Texture(ti); map.encoding = THREE.sRGBEncoding; map.anisotropy = renderer.capabilities.getMaxAnisotropy(); map.needsUpdate = true;
    const mat = new THREE.MeshPhysicalMaterial({ map, alphaTest: 0.5, roughness: 0.3, metalness: 0.08, clearcoat: 1, clearcoatRoughness: 0.06, envMap: envMap(renderer), envMapIntensity: 0.75 });
    const uT = { value: 0 };
    mat.onBeforeCompile = (sh) => {
      sh.uniforms.uT = uT;
      sh.vertexShader = 'uniform float uT;\n' + sh.vertexShader.replace('#include <begin_vertex>',
        'vec3 transformed = vec3(position);\nfloat kyE = pow(abs(position.x) / ' + (W / 2).toFixed(2) + ', 1.6);\ntransformed.z += sin(position.x * 1.4 - uT * 4.2) * 0.13 * kyE;');
    };
    const mesh = new THREE.Mesh(g, mat);
    const group = new THREE.Group(); group.add(mesh);
    const sc = document.createElement('canvas'); sc.width = sc.height = 128; const sx = sc.getContext('2d');
    const gr = sx.createRadialGradient(64, 64, 4, 64, 64, 64); gr.addColorStop(0, 'rgba(0,0,0,.55)'); gr.addColorStop(1, 'rgba(0,0,0,0)'); sx.fillStyle = gr; sx.fillRect(0, 0, 128, 128);
    const shadow = new THREE.Mesh(new THREE.PlaneGeometry(W * 1.1, W * 0.35), new THREE.MeshBasicMaterial({ map: new THREE.CanvasTexture(sc), transparent: true, depthWrite: false }));
    shadow.rotation.x = -Math.PI / 2; shadow.position.y = -Math.max(H / 2, 0.6) - 0.9;
    return { group, shadow, mesh, uT, H };
  }

  function initLure(canvas) {
    if (canvas.dataset.l3 || !window.THREE) return;
    if (!canvas.dataset.tex) return initProcLure(canvas);
    canvas.dataset.l3 = '1';
    const hero = canvas.hasAttribute('data-hero-lure');
    const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: !MOBILE, powerPreference: 'high-performance' });
    renderer.outputEncoding = THREE.sRGBEncoding; renderer.toneMapping = THREE.ACESFilmicToneMapping; renderer.toneMappingExposure = 1.0;
    const scene = new THREE.Scene(); const cam = new THREE.PerspectiveCamera(34, 1, 0.1, 100); cam.position.set(0, 0.6, 8.2);
    scene.add(new THREE.AmbientLight(0xbfd2e0, 0.55));
    const key = new THREE.DirectionalLight(0xffffff, 1.5); key.position.set(2, 4, 5); scene.add(key);
    const rim = new THREE.PointLight(0x4fc3ff, 1.6, 20); rim.position.set(-4, 1, -3); scene.add(rim);
    const rim2 = new THREE.PointLight(0x7fe3f0, 1.2, 20); rim2.position.set(4, -1, -3); scene.add(rim2);
    const pn = 160, pgeo = new THREE.BufferGeometry(), pa = new Float32Array(pn * 3);
    for (let i = 0; i < pn; i++) { pa[i * 3] = (Math.random() - 0.5) * 14; pa[i * 3 + 1] = (Math.random() - 0.5) * 7; pa[i * 3 + 2] = (Math.random() - 0.5) * 8 - 1; }
    pgeo.setAttribute('position', new THREE.BufferAttribute(pa, 3));
    const pts = new THREE.Points(pgeo, new THREE.PointsMaterial({ color: 0x7fe3f0, size: 0.03, transparent: true, opacity: 0.55 }));
    scene.add(pts);
    function size() { const w = canvas.clientWidth, h = canvas.clientHeight; if (!w || !h) return; renderer.setPixelRatio(DPR); renderer.setSize(w, h, false); cam.aspect = w / h; const need = 5 * 1.3, fitZ = need / (2 * Math.tan((34 * Math.PI) / 360) * cam.aspect); cam.position.z = Math.max(6.8, fitZ); cam.updateProjectionMatrix(); }
    size(); addEventListener('resize', size);
    // rotation bornée autour du profil : de côté, le modèle = la photo catalogue à l'identique
    let L = null, rx = 0.06, ry = 0, tx = rx, ty = ry, drag = false, px = 0, py = 0, scrollRot = 0, boost = 0, visible = true, intro = 0;
    const clamp = (v, m) => Math.max(-m, Math.min(m, v));
    canvas.addEventListener('pointermove', (e) => { if (drag || e.pointerType !== 'mouse') return; const r = canvas.getBoundingClientRect(); tx = ((e.clientY - r.top) / r.height - 0.5) * 0.5; ty = ((e.clientX - r.left) / r.width - 0.5) * 1.1; });
    canvas.addEventListener('pointerdown', (e) => { drag = true; px = e.clientX; py = e.clientY; canvas.setPointerCapture?.(e.pointerId); });
    addEventListener('pointerup', () => (drag = false)); addEventListener('pointercancel', () => (drag = false));
    addEventListener('pointermove', (e) => { if (drag) { ty = clamp(ty + (e.clientX - px) * 0.008, 0.6); tx = clamp(tx + (e.clientY - py) * 0.005, 0.3); boost = clamp((e.clientX - px) * 0.02, 0.4); px = e.clientX; py = e.clientY; } });
    new IntersectionObserver((es) => (visible = es[0].isIntersecting), { threshold: 0 }).observe(canvas);
    if (hero && !MOBILE) addEventListener('scroll', () => (scrollRot = Math.sin(window.scrollY * 0.003) * 0.3), { passive: true });
    let loadId = 0;
    const load = (tex, depth, thick) => {
      const id = ++loadId;
      return buildPhotoLure(renderer, tex, depth, thick).then((r) => {
        if (id !== loadId) return;
        if (L) { scene.remove(L.group); scene.remove(L.shadow); L.mesh.geometry.dispose(); L.mesh.material.map.dispose(); L.mesh.material.dispose(); }
        L = r; scene.add(r.group); scene.add(r.shadow); intro = performance.now();
        canvas.classList.add('is-ready');
      }).catch((e) => { console.warn('KRYØS 3D', e); });
    };
    canvas._lure = { setColor() {}, pulse() { boost = 0.6; }, load };
    load(canvas.dataset.tex, canvas.dataset.depth, parseFloat(canvas.dataset.thick || '0.08'));
    const t00 = performance.now();
    let lastF = 0;
    (function loop(now) {
      requestAnimationFrame(loop);
      if (!visible || !pageVisible) return;
      if (MOBILE) { if (scrolling || now - lastF < 33) return; lastF = now; }
      const t = now - t00;
      ry += (ty - ry) * 0.06; rx += (tx - rx) * 0.06; boost *= 0.93;
      if (L) {
        const k = Math.min(1, (now - intro) / 1600), e = 1 - Math.pow(1 - k, 4);
        L.group.scale.setScalar(0.6 + 0.4 * e);
        L.group.rotation.y = clamp(ry + scrollRot + Math.sin(t * 0.0004) * 0.22 + boost, 0.72) + (1 - e) * 1.2;
        L.group.rotation.x = clamp(rx + Math.sin(t * 0.0007) * 0.05, 0.32);
        L.group.rotation.z = Math.sin(t * 0.0009) * 0.04;
        L.group.position.y = Math.sin(t * 0.0012) * 0.16;
        L.uT.value = t / 1000;
        L.shadow.material.opacity = 0.7 - Math.sin(t * 0.0012) * 0.15;
      }
      pts.rotation.y = t * 0.00004; pts.position.y = Math.sin(t * 0.0006) * 0.1;
      renderer.render(scene, cam);
    })(0);
  }

  /* ---------- Hero shader ---------- */
  const VS = 'void main(){gl_Position=vec4(position,1.);}';
  const FS = `
precision highp float;
uniform float t; uniform vec2 res; uniform vec2 m; uniform float sc;
float h(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}
float n(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);return mix(mix(h(i),h(i+vec2(1,0)),f.x),mix(h(i+vec2(0,1)),h(i+vec2(1,1)),f.x),f.y);}
float fbm(vec2 p){float v=0.,a=.5;for(int i=0;i<5;i++){v+=a*n(p);p=p*2.02+vec2(3.1,1.7);a*=.5;}return v;}
void main(){
  vec2 uv=gl_FragCoord.xy/res; float asp=res.x/res.y;
  vec2 p=(uv-.5)*vec2(asp,1.); vec2 mm=(m-.5)*vec2(asp,1.);
  float d=length(p-mm);
  vec2 q=p*2.1+vec2(0.,t*.045+sc*.4);
  vec2 w1=vec2(fbm(q+t*.05),fbm(q+vec2(5.2,1.3)-t*.04));
  float w=fbm(q+w1*1.9+ (mm-p)*.15/(d+.35));
  float c=abs(sin(w*10.+t*.3)); c=pow(1.-c,7.);
  float c2=abs(sin(w*18.-t*.2)); c2=pow(1.-c2,10.);
  vec3 col=vec3(.006,.016,.024);
  col+=vec3(.04,.26,.60)*smoothstep(1.,0.,length(p-vec2(-.65,.45)))*.32;
  col+=vec3(.12,.5,.6)*smoothstep(1.1,0.,length(p-vec2(.75,.25)))*.24;
  col+=c*vec3(.3,.66,.78)*.17*(.55+.6*w);
  col+=c2*vec3(.45,.80,1.)*.07;
  col+=vec3(.25,.65,1.)*smoothstep(.42,0.,d)*.32*(.4+w);
  col*=1.-.6*length(uv-.5);
  col+=(h(gl_FragCoord.xy+t)-.5)*.02;
  gl_FragColor=vec4(col,1.);
}`;
  function initHeroGL(canvas) {
    if (canvas.dataset.gl || !window.THREE) return;
    canvas.dataset.gl = '1';
    let renderer;
    try { renderer = new THREE.WebGLRenderer({ canvas, antialias: false, alpha: false, powerPreference: 'low-power' }); } catch (e) { return; }
    const scene = new THREE.Scene(), cam = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
    const U = { t: { value: 0 }, res: { value: new THREE.Vector2(1, 1) }, m: { value: new THREE.Vector2(0.5, 0.5) }, sc: { value: 0 } };
    scene.add(new THREE.Mesh(new THREE.PlaneGeometry(2, 2), new THREE.ShaderMaterial({ vertexShader: VS, fragmentShader: FS, uniforms: U })));
    const Q = MOBILE ? 0.32 : 0.5; // résolution interne
    function size() { const w = canvas.clientWidth, h = canvas.clientHeight; if (!w || !h) return; renderer.setPixelRatio(Math.min(devicePixelRatio, 1.5) * Q); renderer.setSize(w, h, false); U.res.value.set(canvas.width, canvas.height); }
    size(); addEventListener('resize', size);
    let mx = 0.5, my = 0.5, cx = 0.5, cy = 0.5, visible = true;
    addEventListener('pointermove', (e) => { const r = canvas.getBoundingClientRect(); mx = (e.clientX - r.left) / r.width; my = 1 - (e.clientY - r.top) / r.height; }, { passive: true });
    addEventListener('scroll', () => (U.sc.value = window.scrollY * 0.0008), { passive: true });
    new IntersectionObserver((es) => (visible = es[0].isIntersecting)).observe(canvas);
    const t0 = performance.now();
    let last = 0;
    (function loop(now) {
      requestAnimationFrame(loop);
      if (!visible || !pageVisible) return;
      if (MOBILE && (scrolling || now - last < 32)) return;
      last = now;
      cx += (mx - cx) * 0.05; cy += (my - cy) * 0.05;
      U.m.value.set(cx, cy); U.t.value = reduce ? 4 : (now - t0) / 1000;
      renderer.render(scene, cam);
    })(0);
  }

  /* ---------- 3D sur toutes les cartes : UN seul contexte WebGL, rendu dans chaque carte (scissor) ---------- */
  const cardItems = [];
  let cardGL = null;
  function pose(it, now, t) {
    if (!it.shown) it.shown = now;
    const k = Math.min(1, (now - it.shown) / 1400), e = 1 - Math.pow(1 - k, 4);
    it.ry += (it.ty - it.ry) * 0.07; it.rx += (it.tx - it.rx) * 0.07;
    const g = it.L.group;
    g.visible = true;
    g.scale.setScalar((0.55 + 0.45 * e) * it.fit * (it.hover ? 1.08 : 1));
    g.rotation.y = Math.max(-0.7, Math.min(0.7, it.ry + Math.sin(t * 0.0005 + it.ph) * 0.25)) + (1 - e) * 1.2;
    g.rotation.x = it.rx + Math.sin(t * 0.0007 + it.ph) * 0.04;
    g.rotation.z = Math.sin(t * 0.0009 + it.ph) * 0.04;
    g.position.y = Math.sin(t * 0.0012 + it.ph) * 0.12;
    it.L.uT.value = t / 1000 + it.ph;
  }
  function initCardLures() {
    if (!window.THREE) return;
    const stages = $$('[data-card-tex]:not([data-c3])');
    if (!stages.length) return;
    if (!cardGL) {
      const canvas = document.createElement('canvas');
      canvas.className = 'ky-cardgl';
      canvas.setAttribute('aria-hidden', 'true');
      // mobile : le calque plein écran fixe avait toujours une image de retard sur le scroll tactile (leurres qui « rebondissent »).
      // Le rendu se fait hors écran puis chaque image est recopiée dans un canvas placé DANS la carte : il défile avec elle.
      if (!MOBILE) (document.getElementById('MainContent') || document.body).appendChild(canvas);
      let renderer;
      try { renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: !MOBILE, powerPreference: MOBILE ? 'default' : 'high-performance' }); } catch (e) { return; }
      renderer.outputEncoding = THREE.sRGBEncoding; renderer.toneMapping = THREE.ACESFilmicToneMapping; renderer.toneMappingExposure = 1.0;
      renderer.setClearColor(0x000000, 0);
      const scene = new THREE.Scene();
      scene.add(new THREE.AmbientLight(0xbfd2e0, 0.55));
      const key = new THREE.DirectionalLight(0xffffff, 1.5); key.position.set(2, 4, 5); scene.add(key);
      const rim = new THREE.PointLight(0x4fc3ff, 1.4, 20); rim.position.set(-4, 1, -3); scene.add(rim);
      const rim2 = new THREE.PointLight(0x7fe3f0, 1.1, 20); rim2.position.set(4, -1, -3); scene.add(rim2);
      const cam = new THREE.PerspectiveCamera(30, 1, 0.1, 100); cam.position.set(0, 0.25, 11);
      cardGL = { canvas, renderer, scene, cam };
      const vw = () => document.documentElement.clientWidth, vh = () => document.documentElement.clientHeight;
      const PRM = Math.min(1.5, devicePixelRatio || 1);
      const size = () => { if (MOBILE) return; renderer.setPixelRatio(Math.min(1.5, devicePixelRatio)); renderer.setSize(vw(), vh(), false); };
      if (MOBILE) renderer.setPixelRatio(PRM);
      size(); addEventListener('resize', size);
      const t0 = performance.now();
      let last = 0;
      (function loop(now) {
        requestAnimationFrame(loop);
        if (!pageVisible) return;
        if (MOBILE) { if (scrolling || now - last < 33) return; last = now; } // 30 i/s suffisent pour l'ondulation, la batterie dit merci
        const t = now - t0;
        const H = vh();
        if (MOBILE) {
          for (const it of cardItems) {
            if (!it.L) continue;
            const r = it.stage.getBoundingClientRect();
            if (!(r.width > 0 && r.bottom > 0 && r.top < H && (!it.clip || it.clip.classList.contains('visible')))) continue;
            const w = Math.round(r.width), h = Math.round(r.height);
            if (!it.cv) { it.cv = document.createElement('canvas'); it.cv.className = 'cut-cv'; it.cv.setAttribute('aria-hidden', 'true'); it.stage.appendChild(it.cv); it.ctx = it.cv.getContext('2d'); }
            const cw = Math.round(w * PRM), ch = Math.round(h * PRM);
            if (it.cv.width !== cw || it.cv.height !== ch) { it.cv.width = cw; it.cv.height = ch; }
            if (cardGL.w !== w || cardGL.h !== h) { renderer.setSize(w, h, false); cardGL.w = w; cardGL.h = h; }
            pose(it, now, t);
            cam.aspect = w / h; cam.updateProjectionMatrix();
            renderer.setScissorTest(false); renderer.setViewport(0, 0, w, h); renderer.clear();
            renderer.render(scene, cam);
            it.L.group.visible = false;
            it.ctx.clearRect(0, 0, cw, ch); it.ctx.drawImage(canvas, 0, 0, cw, ch);
            if (!it.drawn) { it.drawn = true; it.stage.classList.add('is-3d'); }
          }
          return;
        }
        const any = cardItems.some((it) => { if (!it.L) return false; const r = it.stage.getBoundingClientRect(); return r.width > 0 && r.bottom > -40 && r.top < H + 40; });
        if (!any) { if (cardGL.dirty) { renderer.setScissorTest(false); renderer.clear(); cardGL.dirty = false; } return; }
        cardGL.dirty = true;
        renderer.setScissorTest(false); renderer.clear(); renderer.setScissorTest(true);
        let drawn = 0;
        for (const it of cardItems) {
          if (!it.L) continue;
          const r = it.stage.getBoundingClientRect();
          const on = r.width > 0 && r.bottom > -40 && r.top < H + 40 && (!it.clip || it.clip.classList.contains('visible'));
          it.L.group.visible = false;
          if (!on) continue;
          pose(it, now, t);
          cam.aspect = r.width / r.height; cam.updateProjectionMatrix();
          renderer.setViewport(r.left, H - r.bottom, r.width, r.height);
          renderer.setScissor(r.left, H - r.bottom, r.width, r.height);
          renderer.render(scene, cam);
          it.L.group.visible = false;
          drawn++;
        }
      })(0);
    }
    const io = new IntersectionObserver((es) => es.forEach((en) => {
      if (!en.isIntersecting) return;
      io.unobserve(en.target);
      const it = en.target._ky; if (!it || it.loading) return;
      it.loading = true;
      const img = it.stage.querySelector('img.cut');
      const pickSrc = () => new Promise((res) => {
        if (!img) return res(it.stage.dataset.cardTex);
        if (img.complete && img.currentSrc) return res(img.currentSrc);
        img.addEventListener('load', () => res(img.currentSrc || it.stage.dataset.cardTex), { once: true });
        img.addEventListener('error', () => res(it.stage.dataset.cardTex), { once: true });
        setTimeout(() => res(img.currentSrc || it.stage.dataset.cardTex), 3000);
      });
      pickSrc().then((src) => buildPhotoLure(cardGL.renderer, src, it.stage.dataset.cardDepth, parseFloat(it.stage.dataset.cardThick || '0.08'))).then((L) => {
        L.group.visible = false; cardGL.scene.add(L.group);
        // cadrage : le leurre (largeur 5) occupe ~82% de la carte, hauteur bornée
        const r = it.stage.getBoundingClientRect(), asp = r.width / Math.max(1, r.height);
        const visH = 2 * 11 * Math.tan((30 * Math.PI) / 360), visW = visH * asp;
        it.fit = Math.min((visW * 0.82) / 5, (visH * 0.78) / Math.max(0.6, L.H));
        it.L = L;
        if (!MOBILE) it.stage.classList.add('is-3d');
      }).catch((e) => console.warn('KRYØS card 3D', e));
    }), { rootMargin: '400px 0px' });
    stages.forEach((stage, i) => {
      stage.dataset.c3 = '1';
      const card = stage.closest('.product') || stage;
      const it = { stage, clip: stage.closest('.clip'), rx: 0.05, ry: 0, tx: 0.05, ty: 0, ph: i * 1.7, fit: 1, hover: false };
      stage._ky = it; cardItems.push(it);
      card.addEventListener('pointermove', (e) => { if (e.pointerType !== 'mouse') return; const r = card.getBoundingClientRect(); it.hover = true; it.ty = ((e.clientX - r.left) / r.width - 0.5) * 1.2; it.tx = ((e.clientY - r.top) / r.height - 0.5) * 0.5; });
      card.addEventListener('pointerleave', () => { it.hover = false; it.ty = 0; it.tx = 0.05; });
      io.observe(stage);
    });
  }

  function boot() {
    initCardLures();
    $$('canvas[data-lure3d]').forEach(initLure);
    $$('canvas[data-hero-gl]').forEach(initHeroGL);
    // hero colour swatches
    $$('.color-sw[data-for]').forEach((sw) => {
      const cv = document.getElementById(sw.dataset.for); if (!cv || sw.dataset.b) return; sw.dataset.b = '1';
      $$('button', sw).forEach((b) => b.addEventListener('click', () => { $$('button', sw).forEach((x) => x.classList.remove('active')); b.classList.add('active'); cv._lure && cv._lure.setColor(b.dataset.c); }));
    });
  }
  K.init3d = boot;
  if (MOBILE) {
    const idle = () => ('requestIdleCallback' in window ? requestIdleCallback(boot, { timeout: 2500 }) : setTimeout(boot, 300));
    if (document.readyState === 'complete') idle(); else addEventListener('load', idle, { once: true });
  } else if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
